/* eslint-disable prettier/prettier */
import { useEffect, useContext, useState, Suspense, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent, Button, Grid, FormControlLabel, Switch, IconButton } from "@material-ui/core";
import axios from "axios";
import { LazySnackbarAPI } from "../../../shared";
import { LazyCustomDialog } from "../../../shared";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import prefixCharacterAddition from "../../../../utils/commonFunctions/prefixCharacterAddition";
import { port, url, headers } from "../../../../config/config";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { api } from "../../../../utils/api";
import { trackPromise } from "react-promise-tracker";
import { SnackbarProps } from "../../../../@types/snackbarAPI.types";
import { UIContext, AuthContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import ROLES from "../../../../constants/roles";
import { withStyles } from "@material-ui/core/styles";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ReplyIcon from "@material-ui/icons/Reply";
import GroupIcon from "@material-ui/icons/Group";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

import "./userInformation.css";
import { useEmployerRoute, useEnroller } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import { ENROLLER_TYPE } from "../../../../constants/enrollerType";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { formatSSNHide } from "../../../../utils/commonFunctions/SSN";
const GreenSwitch = withStyles({
	switchBase: {
		// color: "#359a4c",
		"&$checked": {
			color: "#d4372f"
		},
		"&$checked + $track": {
			backgroundColor: "rgb(204, 113, 110)"
		}
	},
	checked: {},
	track: {
		// backgroundColor: "rgb(60, 179, 113)"
	}
})(Switch);

const UserInformation = () => {
	const { isEnroller } = useEnroller();
	const [showSSN, setShowSSN] = useState(false);
	const [users, setUsers] = useState<any>({
		_id: "",
		first_name: "",
		last_name: "",
		user_name: "",
		email: "",
		date: "",
		last_login_date: "",
		role: "",
		SSN: "",
		date_of_birth: "",
		is_approved: "",
		approved_by: "",
		is_member_support: "",
		is_employer_support: "",
		is_disabled: ""
	});
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const [customDisableUserDialgProps, setCustomDisableUserDialogProps] = useState({
		openDialog: false,
		title: "Do you want to Disable the user?",
		content: "If yes, then click on Confirm, otherwise click on Cancel",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					handleCloseDisableUserDialogClick();
				}
			},
			{
				label: "Confirm",
				name: "confirm",
				callback: () => {
					handleDisableUserClick();
				}
			}
		]
	});
	const [customEnableUserDialgProps, setCustomEnableUserDialgProps] = useState({
		openDialog: false,
		title: "Do you want to Enable the user ?",
		content: "If yes then click on Confirm, otherwise click on Cancel",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					handleCloseEnableUserDialogClick();
				}
			},
			{
				label: "Confirm",
				name: "confirm",
				callback: () => {
					handleEnableUserClick();
				}
			}
		]
	});
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const navigate = useNavigate();
	const { state } = useLocation() as { state: { user_id: string } };
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);
	const [isClaimVisibilityClick, setIsClaimVisibilityClick] = useState<boolean>(false);

	const handleEditUserClick = useCallback(() => {
		const pathname = `/settings/user/edit-user?id=${users?._id}`;
		navigate(pathname);
	}, [navigate, users?._id]);

	const handleGroupAssign = useCallback(() => {
		if (queryGroupNumber !== undefined && isEmployerRoute !== null) {
			const pathname = isEmployerRoute
				? `/employer/settings/user/assign-groups?gn=${queryGroupNumber}`
				: "/settings/user/assign-groups";
			const key = "user_id";
			const value = users?._id;
			const roleKey = "role";
			navigate(pathname, {
				state: {
					[key]: value,
					[roleKey]: users?.role
				}
			});
		}
	}, [isEmployerRoute, navigate, queryGroupNumber, users?._id, users?.role]);

	const toggleSSNVisibility = useCallback(() => {
		// eslint-disable-next-line
		setShowSSN((prev) => !prev);
	}, []);

	// open and closing of dialog box
	// for disable
	const handleOpenDisableUserDialogClick = useCallback(() => {
		setCustomDisableUserDialogProps(Object.assign({}, customDisableUserDialgProps, { openDialog: true }));
	}, [customDisableUserDialgProps]);

	const handleCloseDisableUserDialogClick = useCallback(() => {
		setCustomDisableUserDialogProps(Object.assign({}, customDisableUserDialgProps, { openDialog: false }));
	}, [customDisableUserDialgProps]);

	// for enable
	const handleOpenEnableUserDialogClick = useCallback(() => {
		setCustomEnableUserDialgProps(Object.assign({}, customEnableUserDialgProps, { openDialog: true }));
	}, [customEnableUserDialgProps]);

	const handleCloseEnableUserDialogClick = useCallback(() => {
		setCustomEnableUserDialgProps(Object.assign({}, customEnableUserDialgProps, { openDialog: false }));
	}, [customEnableUserDialgProps]);

	//Update Claim Status
	const handleEditClaimVisibilityClick = useCallback(() => {
		setIsClaimVisibilityClick(true);
	}, []);

	const updateClaimVisibility = useCallback(
		async (id: string) => {
			// console.log("UpdateClaimStatusPayload2222", !users.is_claim_visibility);
			const payload = {
				is_claim_visibility: !users.is_claim_visibility
			};

			// console.log("UpdateClaimStatusPayload", payload);
			const response = await trackPromise(api.auth.editClaimVisibilityById(payload, id));
			// console.log("===response.is_claim_visibility===", response.is_claim_visibility);
			if (response) {
				alert("Claim Status Updation Successful!");
				window.location.reload();
			}
		},
		[users.is_claim_visibility]
	);

	// Disable users function
	const handleDisableUserClick = useCallback(async () => {
		const { user_id } = state;
		// console.log("user -id ", user_id);

		const payload = {
			is_disabled: true
		};

		try {
			const response = await trackPromise(api.auth.enableAndDisableUserById(payload, user_id));

			if (response) {
				setUsers(Object.assign({}, response));
				alert("User has been disabled successfully!");
				handleCloseDisableUserDialogClick();
				// window.location.reload();
			}
		} catch (error) {
			console.log("Error", error);
		}
	}, [handleCloseDisableUserDialogClick, state]);

	// Enable user function
	const handleEnableUserClick = useCallback(async () => {
		const { user_id } = state;
		// console.log("user -id ", user_id);

		const payload = {
			is_disabled: false
		};

		try {
			const response = await trackPromise(api.auth.enableAndDisableUserById(payload, user_id));

			if (response) {
				setUsers(Object.assign({}, response));
				alert("User has been enabled successfully!");
				handleCloseEnableUserDialogClick();
				// window.location.reload();
			}
		} catch (error) {
			console.log("Error", error);
		}
	}, [handleCloseEnableUserDialogClick, state]);
	// const handleEnableUserClick = useCallback(async () => {
	// 	const { user_id } = state;
	// 	// const userInstances = await trackPromise(api.groupOwner.getGroupOwnerById(user_id));
	// 	const params = user_id;

	// 	const payload = {
	// 		is_disabled: false
	// 	};

	// 	try {
	// 		const response = await trackPromise(api.auth.enableAndDisableUserById(payload, params));

	// 		if (response) {
	// 			alert("User has been Enabled Successfully");
	// 			setSnackbarAPICallProps(
	// 				Object.assign({}, snackbarAPICallProps, {
	// 					open: true,
	// 					message: "Successfully changed access status",
	// 					severity: "success"
	// 				})
	// 			);
	// 			setUsers(Object.assign({}, users, { is_disabled: false }));
	// 		}
	// 	} catch (error) {
	// 		console.log("Error", error);
	// 	}
	// }, [snackbarAPICallProps, state, users]);

	// Enable User Function
	// const handleEnableUserClick = useCallback(async () => {
	// 	const payload = JSON.stringify(user);
	// 	const { Authorization, Bearer } = AUTHORIZATION;
	// 	const token = localStorage.getItem("@jwt");

	// 	try {
	// 		const response = await trackPromise(
	// 			axios.put(`${url}:${port}/api/v1/super-admin/approve-request?id=${_id}`, payload, {
	// 				headers: {
	// 					...headers,
	// 					[Authorization]: `${Bearer} ${token}`
	// 				}
	// 			})
	// 		);
	// 		setUsers(Object.assign({}, response.data.result));
	// 		setSnackbarAPICallProps(
	// 			Object.assign({}, snackbarAPICallProps, {
	// 				open: true,
	// 				message: "Successfully approved user",
	// 				severity: "success"
	// 			})
	// 		);
	// 	} catch (err) {
	// 		console.log("err", err);
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [history, user]);

	const getUserInformation = useCallback(async (_id: string) => {
		const users = await trackPromise(api.groupOwner.getGroupOwnerById(_id));
		if (users) {
			const { SSN, date_of_birth, date, last_login_date } = users;
			const ssn = SSN ? SSN.substring(0, 3) + "-" + SSN.substring(3, 5) + "-" + SSN.substring(5) : null;
			const DOB = date_of_birth ? new Date(date_of_birth) : null;
			const createDate = date ? new Date(date) : null;
			const loginDate = last_login_date ? new Date(last_login_date) : null;
			const _user = {
				...users,
				SSN: ssn !== null ? ssn : "",
				date_of_birth:
					DOB !== null
						? prefixCharacterAddition(DOB.getMonth() + 1) +
						"-" +
						prefixCharacterAddition(DOB.getDate()) +
						"-" +
						DOB.getFullYear()
						: DOB,
				date:
					createDate !== null
						? prefixCharacterAddition(createDate.getMonth() + 1) +
						"-" +
						prefixCharacterAddition(createDate.getDate()) +
						"-" +
						createDate.getFullYear()
						: createDate,
				last_login_date:
					loginDate !== null
						? prefixCharacterAddition(loginDate.getMonth() + 1) +
						"-" +
						prefixCharacterAddition(loginDate.getDate()) +
						"-" +
						loginDate.getFullYear()
						: loginDate
			};
			setUsers(Object.assign({}, _user));
		} else {
			alert("Error: invalid request");
		}
	}, []);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.user_information);

		if (state.user_id) {
			const { user_id } = state;
			getUserInformation(user_id);
		}
	}, [getUserInformation, setDashboardHeader, state]);

	useEffect(() => {
		if (isClaimVisibilityClick) {
			updateClaimVisibility(users._id);
			setIsClaimVisibilityClick(false);
		}
	}, [isClaimVisibilityClick, updateClaimVisibility, users._id]);

	const {
		_id,
		SSN,
		date_of_birth,
		first_name,
		last_name,
		user_name,
		email,
		date,
		last_login_date,
		role,
		is_registered,
		type,
		writing_number,
		is_disabled
	} = users;

	return (
		<div className="user-information" id="user-information">
			<Suspense fallback={<div />}>
				<LazyCustomDialog
					dialogProps={customDisableUserDialgProps}
					handleClose={handleCloseDisableUserDialogClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<LazyCustomDialog
					dialogProps={customEnableUserDialgProps}
					handleClose={handleCloseEnableUserDialogClick}
				/>
			</Suspense>
			<Suspense fallback={<div />}>
				<LazySnackbarAPI snackbarProps={snackbarAPICallProps} />
			</Suspense>
			{users ? (
				<>
					<div className="role-container">
						<Grid container spacing={1} direction="row" alignItems="center" justify="center">
							<Grid item xs={12} sm={12} md={2} lg={2} xl={2}></Grid>
							<Grid item xs={12} sm={12} lg={4} xl={4}>
								<span style={{ marginRight: 10 }}>Role:</span>
								<span style={{ color: "#44b700" }}>
									{role === ROLES.employer && (type === "ENROLLER ADMIN" || type === "AGENT")
										? initCapitalize(type)
										: initCapitalize(role)}
								</span>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								lg={6}
								xl={6}
								style={{
									display:
										user?.role === ROLES.super_admin
											? "flex"
											: user?.role === ROLES.admin
												? "flex"
												: user?.role === ROLES.employer && type === null
													? "flex"
													: isEnroller
														? "none"
														: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end"
								}}
							>
								<Button
									className={
										is_disabled ? "button-green button-margin" : "button-black button-margin"
									}
									variant="contained"
									onClick={handleEditUserClick}
								>
									<span className="button-label-with-icon">Edit User</span>
									<span>
										<EditIcon className="button-icon" />
									</span>
								</Button>
								<Button
									className={
										is_disabled ? "button-black button-margin" : "button-green button-margin"
									}
									variant="contained"
									onClick={handleGroupAssign}
								>
									<span className="button-label-with-icon">Group Assign</span>
									<span>
										<GroupIcon className="button-icon" />
									</span>
								</Button>
								<Button
									className={
										is_disabled ? "button-green button-margin" : "button-black button-margin"
									}
									onClick={
										is_disabled ? handleOpenEnableUserDialogClick : handleOpenDisableUserDialogClick
									}
								>
									<span className="button-label-with-icon">
										{is_disabled ? "Enable User" : "Disable User"}
									</span>
									<span>
										{is_disabled ? (
											<CheckCircleIcon className="button-icon" />
										) : (
											<RemoveCircleIcon className="button-icon" />
										)}
									</span>
								</Button>
							</Grid>
						</Grid>
					</div>
					<div className="cards-container">
						<Grid container spacing={2}>
							<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
								<Card className="hoverable">
									<CardContent>
										<div className="card-header">Primary Information</div>
										<div className="card-body">
											{/* <div className="details-container">
												<span className="label-text">
													<ArrowForwardIosIcon
														style={{
															fontSize: "0.9rem",
															paddingTop: 4
														}}
													/>
												</span>
												<span className="label-text">Company:</span>
												<span className="value-text">Dallas Warehouse</span>
											</div> */}
											<div className="details-container">
												<span className="label-text">
													<ArrowForwardIosIcon
														style={{
															fontSize: "0.9rem",
															paddingTop: 4
														}}
													/>
												</span>
												<span className="label-text">First Name:</span>
												<span className="value-text">{first_name}</span>
											</div>
											<div className="details-container">
												<span className="label-text">
													<ArrowForwardIosIcon
														style={{
															fontSize: "0.9rem",
															paddingTop: 4
														}}
													/>
												</span>
												<span className="label-text">Last Name:</span>
												<span className="value-text">{last_name}</span>
											</div>
											<div
												className="details-container"
												style={{ display: "flex", alignItems: "center", gap: "8px" }}
											>
												<ArrowForwardIosIcon style={{ fontSize: "0.9rem", paddingTop: 4 }} />
												<span className="label-text">SSN:</span>
												{SSN ? (
													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "8px"
														}}
													>
														<span>{showSSN ? SSN : formatSSNHide(SSN)}</span>
														<IconButton
															onClick={toggleSSNVisibility}
															size="small"
															style={{
																padding: "4px",
																color: showSSN ? "red" : "green"
															}}
															title={showSSN ? "Hide SSN" : "Show SSN"}
														>
															{showSSN ? <FaEye /> : <FaEyeSlash />}
														</IconButton>
													</div>
												) : (
													"N/A"
												)}
											</div>

											<div className="details-container">
												<span className="label-text">
													<ArrowForwardIosIcon
														style={{
															fontSize: "0.9rem",
															paddingTop: 4
														}}
													/>
												</span>
												<span className="label-text">Date of Birth:</span>
												<span className="value-text">
													{date_of_birth
														? (dateTimeZoneConverter(date_of_birth as string) as string)
														: "N/A"}
												</span>
											</div>
											{role === ROLES.employer &&
												(type === "ENROLLER ADMIN" || type === "AGENT") ? (
												<div className="details-container">
													<span className="label-text">
														<ArrowForwardIosIcon
															style={{
																fontSize: "0.9rem",
																paddingTop: 4
															}}
														/>
													</span>
													<span className="label-text">Writing Number:</span>
													<span className="value-text">
														{writing_number ? writing_number : "N/A"}
													</span>
												</div>
											) : null}
										</div>
									</CardContent>
								</Card>
							</Grid>
							<Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
								<Card>
									<CardContent>
										<div className="card-header">Personal Information</div>
										<div className="personal-content" id="personal-content">
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														User Name:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">{user_name}</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Registered User:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">{is_registered ? "Yes" : "No"}</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Disabled User:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">
														{is_disabled === true
															? "Yes"
															: is_disabled === false
																? "No"
																: "N/A"}
													</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Email:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">{email}</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Creation Date:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">
														{date
															? (dateTimeZoneConverter(date as string) as string)
															: "N/A"}
													</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Last Login Date:
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">
														{last_login_date !== null
															? (dateTimeZoneConverter(
																last_login_date as string
															) as string)
															: "Yet to login"}
													</div>
												</Grid>
											</Grid>
											{user?.role === ROLES.super_admin || user?.role === ROLES.admin ? (
												<Grid
													container
													spacing={1}
													justify="flex-start"
													alignItems="center"
													direction="row"
												>
													<Grid item>
														<div className="personal-label-text">
															<span>
																<ReplyIcon
																	style={{
																		fontSize: "1.6rem",
																		paddingTop: 12
																	}}
																/>
															</span>
															Claim Visibility
														</div>
													</Grid>
													{/* <Grid item>
													<div className="value-text">
														<FormControlLabel
															control={<Switch defaultChecked />}
															label=""
														/>
													</div>
												</Grid> */}
													<Grid item>
														<GreenSwitch
															checked={
																users.is_claim_visibility !== undefined
																	? users.is_claim_visibility
																	: null
															}
															onChange={handleEditClaimVisibilityClick}
															name="plan-switch"
														/>
													</Grid>
												</Grid>
											) : null}

											{/* <Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Is member support
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">{is_member_support ? "Yes" : "No"}</div>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={1}
												justify="flex-start"
												alignItems="center"
												direction="row"
											>
												<Grid item>
													<div className="personal-label-text">
														<span>
															<ReplyIcon
																style={{
																	fontSize: "1.6rem",
																	paddingTop: 12
																}}
															/>
														</span>
														Is employer support
													</div>
												</Grid>
												<Grid item>
													<div className="value-text">
														{is_employer_support ? "Yes" : "No"}
													</div>
												</Grid>
											</Grid> */}
										</div>
									</CardContent>
								</Card>
							</Grid>
						</Grid>
					</div>
				</>
			) : null}
		</div>
	);
};

export default UserInformation;
